<template>
  <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="15" :btnSpan="6"
                :multipleLines="false" :inline="true">
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.fieldKey" placeholder="元数据名称">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in metaList" :value="item.enumKey" :key="'keyB'+index">{{item.enumName}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                    placeholder="创建日期筛选"></DatePicker>
      </Col>

    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    components: {
      SearchGroup
    },
    props: {
      metaList: {
        type: Array,
        defalut: () => {
          return []
        }
      }
    },
    mounted() {
      this.$emit('searchData', this.searchDataComputed);
    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }

        return {
          fieldKey: this.searchData.fieldKey,
          beginDate: f(this.searchData.createTime[0]),
          endDate:f(this.searchData.createTime[1])

        }
      }


    },
    data() {
      return {
        signDay: [],
        searchData: {
          fieldKey: '',
          createTime: ['', '']

        },
      }
    },
    methods: {
      findData() {
        this.$emit('searchData', this.searchDataComputed);
      },
      clearValue() {
        this.searchData = {
          fieldKey: '',
          createTime: ['', '']
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
